if (!customElements.get("video-on-scroll")) {
  class VideoOnScroll extends HTMLElement {
    constructor() {
      super();

      this.video = null;
      this.observer = null;
    }

    connectedCallback() {
      const visibleVideo = Array.from(this.querySelectorAll("video")).find((video) => {
        return window.getComputedStyle(video).display !== "none";
      });      

      if (!visibleVideo) {
        return console.error("No visible <video> found in <video-on-scroll>.");    
      }

      this.video = visibleVideo;

      this.video.setAttribute("muted", "");
      this.video.setAttribute("playsinline", "");

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.video.play().catch((error) => {
                console.warn(
                  'Video playback error. Ensure "muted" and "playsinline" attributes are used.',
                  error
                );
              });
            } else {
              this.video.pause();
            }
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.5,
        }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define("video-on-scroll", VideoOnScroll);
}
